module.exports = __webpack_public_path__ + "public/SiteIcons/refundable.svg?be75d24f";